export default __webpack_public_path__ + "static/media/square-placeholder.b952a83e.png";